import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';
import './category.css';
import ProductItems from '../../components/productItems/ProductItems';
import Title from '../../components/title/Title';

export default function Category() {
  const { category } = useParams();
  const { products } = useContext(ShopContext);

  // 👉 Scroll en haut avec effet fluide
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [category]);

  const filteredProducts = Array.isArray(products)
    ? products.filter(
        (product) =>
          product.category?.toLowerCase() === category?.toLowerCase()
      )
    : [];

  return (
    <div className="category-page-container">
      <div className="title-wrapper">
        <Title text1={category.toUpperCase()} text2={'COLLECTION'} />
      </div>

      <div className="products-container">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item) => {
            const price =
              Array.isArray(item.sizes) && item.sizes.length > 0
                ? item.sizes[0].price
                : item.price;
 
            return (
              <div className="product-item-wrapper" key={item._id}>
                <ProductItems
                  name={item.name}
                  slug={item.slug}
                  image={item.image}
                  price={price}
                  date={item.date}
                  className="centered-product-item"
                />
              </div>
            );
          })
        ) : (
          <p style={{ textAlign: 'center' }}>
            Chargement des Produits.
          </p>
        )}
      </div>
    </div>
  );
}
